module.exports = __webpack_public_path__ + "web_static/img/video2.cd687f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/assets/video2.jpg
// module id = 7Zd0
// module chunks = 10